import { IPromise, IHttpService, IRequestShortcutConfig } from "angular";

import { IEmployee, IEmployeeDetails, IEmployeeQueryParams } from "../models/models";
import { EnvironmentService } from "@gtmhub/env";
import { ICollection } from "@gtmhub/models";

import { IRestLayerRequest } from "@gtmhub/core";

export interface IEmployeeCache {
  id: string;
  value?: IEmployeeDetails;
  promise: IPromise<IEmployeeDetails>;
}

export class EmployeeService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getEmployees(queryParams?: IEmployeeQueryParams): IPromise<ICollection<IEmployee>> {
    const url = this.env.getApiEndpoint("/employees");

    const query: IRequestShortcutConfig = {
      params: queryParams,
    };

    return this.$http.get<ICollection<IEmployee>>(url, query).then((response) => response.data);
  }

  public getEmployeesV2(params: IRestLayerRequest): IPromise<ICollection<IEmployee>> {
    const url = this.env.getApiEndpointV2("/employees");
    return this.$http.get<ICollection<IEmployee>>(url, { params }).then((response) => response.data);
  }

  public getEmployee(id: string): IPromise<IEmployeeDetails> {
    const url = this.env.getApiEndpoint("/employees/" + id);

    return this.$http.get(url).then((response) => response.data);
  }
}
